<div
  class="switcher-form--wrapper nx-formfield__wrapper nx-formfield"
  [formGroup]="formGroup"
  [ngClass]="field.class ?? []"
>
  <div
    class="switcher-form--content"
    [ngClass]="['switcher-form--align_' + (field.align ?? 'left')]"
  >
    <nx-switcher
      [labelSize]="field.labelSize ?? 'large'"
      [formControlName]="field.name"
      [checked]="field.checked!"
    >
      <nx-formfield-label>
        <app-custom-link [linkText]="field.label | translate"></app-custom-link>
        <span *ngIf="field.required">*</span>
      </nx-formfield-label>
    </nx-switcher>
  </div>

  <ng-container *ngIf="formGroup.controls[field.name].touched">
    <nx-error
      nxFormfieldError
      *ngFor="
        let item of !field.hideErrorBox &&
          formGroup.controls[field.name]?.errors ?? {} | arrayKeys
      "
    >
      {{
        (field.customErrorLabel && field.customErrorLabel[item]
          ? field.customErrorLabel[item]
          : "azForm.errors." + item
        ) | translate
      }}
    </nx-error>
  </ng-container>
</div>
